package music.jammers.client.shared.component

import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.window.DialogProperties
import limasoul.client.shared.generated.resources.Res
import limasoul.client.shared.generated.resources.dialog_cancel
import limasoul.client.shared.generated.resources.dialog_ok
import org.jetbrains.compose.resources.StringResource
import org.jetbrains.compose.resources.stringResource

@Composable
fun ConfirmationDialog(
    titleStringResource: StringResource,
    contentStringResource: StringResource,
    onPositiveClicked: () -> Unit,
    onNegativeClicked: () -> Unit,
) {
    AlertDialog(
        title = {
            Text(text = stringResource(titleStringResource))
        },
        text = {
            Text(
                text = stringResource(
                    contentStringResource
                )
            )
        },
        onDismissRequest = onNegativeClicked,
        confirmButton = {
            TextButton(onClick = {
                onPositiveClicked()
            }) {
                Text(stringResource(Res.string.dialog_ok))
            }
        },
        dismissButton = {
            TextButton(onClick = {
                onNegativeClicked()
            }) {
                Text(stringResource(Res.string.dialog_cancel))
            }
        },
        properties = DialogProperties(
            dismissOnBackPress = false,
            dismissOnClickOutside = false,
        )
    )
}